import { put, select, takeEvery } from 'redux-saga/effects'
import _ from 'lodash'

import { LOG_ACTION } from './constants'

import { logActionRequest } from './actions'

import { sessionIdSelector } from './selectors'

function* logActionCallSaga(_action) {
    const options = _.get(_action, 'data.options', {})

    const sessionId = yield select(sessionIdSelector)
    yield put(logActionRequest(sessionId, options))

    return null
}

export default function* logActionSaga() {
    yield takeEvery(LOG_ACTION, logActionCallSaga)
}
